// Forced-colors mode (Windows High Contrast) replaces the header and footer gradients with the
// system Canvas colour, which hides the white logo artwork. In that mode only, an image gets a
// fixed dark backplate. `forced-color-adjust: none` sits on the image, not on its link, so the
// link's focus outline keeps its system colour. `box-content` adds the padding around the image
// instead of shrinking it.
export const FORCED_COLORS_BACKPLATE =
  "forced-colors:box-content forced-colors:rounded-sm forced-colors:bg-clm-primary-blue forced-colors:p-0.5 forced-colors:forced-color-adjust-none";
